var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"avatar relative",class:[
		("bg-" + (_vm.props.color) + "-200"),
		("text-" + (_vm.props.color) + "-600"),
		("border-" + (_vm.props.color) + "-800") ]},[(_vm.props.count > 0)?_c('div',{staticClass:"avatar-count absolute  h-6 w-6 text-white border-2 border-gray-300 rounded-full bg-red-500 z-2 text-xs flex justify-center items-center text-center"},[_vm._v(" "+_vm._s(_vm.props.count)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("getInitials")(_vm.props.name))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }